import React, { useState, useEffect } from 'react'
import Link from '@mui/material/Link'
import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Avatar from '@mui/material/Avatar'
import { useStyles } from './styles/index.styles'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import secureLocalStorage from 'react-secure-storage'

import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined'
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined'
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import Badge from '@mui/material/Badge'
import MailIcon from '@mui/icons-material/Mail'
import Popper from '@mui/material/Popper';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { useSocket } from '../../../services/hooks/socketHook';
import { toast } from 'react-toastify';
import Alert from '@mui/material/Alert';

import AvatarHiplade from '../avatarhiplade'

import Breadcrumbs from '../breadcrumbs'
import { AppContext } from '../../../contexts/AppContext'
import useLayoutStyles from '../../hooks/useLayoutStyles'
import { useTheme } from '@mui/material/styles' // Importação necessária para acessar os breakpoints
import Menu from '../menu'
//import logo from './path/to/logo_horizontal.png'; // Importe o logo
import logo_horizontal from "../../../assets/images/logo_horizontal.png"

export default function Header({ showMenu }: any) {
  const classes = useStyles()
  const { t } = useTranslation()
  const { state: { menu } } = React.useContext(AppContext);
  const nameUser = secureLocalStorage.getItem('name')
  const auth_user_id = secureLocalStorage.getItem('id')
  const avatar_url = secureLocalStorage.getItem('avatar_url')
  const [openMenuMobile, setOpenMenuMobile] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [impersonateMode, setImpersonateMode] = useState(false);

  if (secureLocalStorage.getItem("impersonate_mode") === "true" && !impersonateMode) {
    setImpersonateMode(true);
  }

  const handleNotificationClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const listItemsExample = [
  //   { id: 1, title: 'Notificação 1', description: 'Este é um texto de exemplo para a notificação.' },
  //   { id: 2, title: 'Notificação 2', description: 'Outro exemplo de notificação.' },
  //   { id: 3, title: 'Notificação 3', description: 'Mais um item na lista de notificações.' },
  //   { id: 4, title: 'Notificação 4', description: 'Notificação adicional para demonstração.' },
  // ];


  useSocket({
    callBack: (payload) => {
      toast.info(`Notificação: ${payload.message || 'Sucesso! Conteúdo recebido com sucesso.'}`, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    },
    channel: 'user.' + auth_user_id, // Nome do privateChannel na classe do MANAGER
    event: '.App\\Events\\UserNotificationEvent' // Nome de classe caminho completo
  });

  const open = Boolean(anchorEl);
  const id = open ? 'notification-popper' : undefined;


  const navigate = useNavigate()

  const { contentContainerMarginLeft } = useLayoutStyles()
  const theme = useTheme() // Usando o hook useTheme para acessar os breakpoints

  return (
    <Box className={classes.containerHeader} ml={contentContainerMarginLeft+"px"}>
      <CssBaseline />
      <Box
        className={classes.boxContainer}
      >
        <Box className={classes.boxMenuOutlinedIcon}>
          {openMenuMobile ? (
            <CloseOutlinedIcon
              sx={{ mr: 4, fontSize: 36, cursor: 'pointer', display: { xs: 'block', lg: 'none' } }}
              className={classes.iconArrowColor}
              onClick={() => setOpenMenuMobile(false)}
            />
          ) : (
            <MenuOutlinedIcon
              sx={{ mr: 4, fontSize: 36, cursor: 'pointer', display: { xs: 'block', lg: 'none' } }}
              className={classes.iconArrowColor}
              onClick={() => setOpenMenuMobile(true)}
            />

          )}
            <SearchOutlinedIcon
              sx={{ mr: 4, fontSize: 32, cursor: 'pointer', display: { xs: 'block', lg: 'none' } }}
              className={classes.iconArrowColor}
              //onClick={() => setOpenMenuMobile(true)}
            />
        </Box>
        <Box className={classes.boxBreadCrumb} sx={{
          [theme.breakpoints.down('lg')]: {
              marginLeft: 'auto',
              marginRight: 'auto',
              width: '90%',
            },
            [theme.breakpoints.up('lg')]: {
              marginLeft: 'auto',
              marginRight: 'auto',
              width: '94%',
            }
          }}>
          <Box
            className={classes.navButton}
            sx={{ mr: 1, display: { xs: 'none', lg: 'flex' } }}
            onClick={() => navigate(-1)}
          >
            <ArrowBackIosOutlinedIcon
              sx={{ fontSize: 15, ml: '3px' }}
              className={classes.iconArrowColor}
            />
          </Box>
          <Box
            className={classes.navButton}
            sx={{ mr: 3, display: { xs: 'none', lg: 'flex' } }}
            onClick={() => navigate(1)}
          >
            <ArrowForwardIosOutlinedIcon
              sx={{ fontSize: 15 }}
              className={classes.iconArrowColor}
            />
          </Box>
          <Breadcrumbs navigate={navigate} />

        </Box>

        <Box className={classes.boxAvatar} sx={{ display: { xs: 'none', lg: 'flex' } }}>

          {/* <Box className={classes.boxSearch}>
            <SearchOutlinedIcon sx={{ mr: 2, fontSize: 40 }} />
            <TextField
              margin="normal"
              name="search"
              label={t('input_search')}
              type="text"
              size="small"
              className={classes.textSearch}
            />
          </Box> */}
          {/* <HelpCenterOutlinedIcon sx={{ mr: 2, fontSize: 40 }} />
          <NotificationsOutlinedIcon sx={{ mr: 2, fontSize: 40 }} /> */}
          {
            /**
             * TODO: Implementar a lista de notificações,
             * utilizando o Popper do Material-UI para exibir as
             * notificações ao clicar no ícone. A lista de notificações
             * pode ser obtida via WebSocket ou API, e deve ser atualizada
             * dinamicamente conforme novas notificações chegarem.
             * Cada item da lista deve conter um título e uma descrição,
             * e ao clicar em uma notificação, o usuário deve ser redirecionado
             * para a página relevante ou a notificação deve ser marcada como lida.
             */
          }
          {/* <Badge badgeContent={numberNotifications} color="primary">
            <NotificationsOutlinedIcon
              sx={{ mr: 0, fontSize: 32, cursor: 'pointer', display: { xs: 'block', lg: 'block' } }}
              onClick={handleNotificationClick}
              //className={classes.iconArrowColor}
              //onClick={() => setOpenMenuMobile(true)}
            />
          </Badge> */}

          {/* <Popper id={id} open={open} anchorEl={anchorEl}>
            <ClickAwayListener onClickAway={handleClose}>
              <Paper sx={{ border: 1, p: 1, mr: 0.9, mt: 1.9, bgcolor: 'background.paper' }} variant="outlined" square>
                <List sx={{ maxHeight: 200, overflow: 'auto' }}>
                  {listItemsExample.map((item) => (
                    <ListItem key={item.id}>
                      <ListItemText primary={item.title} secondary={item.description} />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </ClickAwayListener>
          </Popper> */}
          <Link href="/users/profile" sx={{ ml: 0, textDecoration: 'none' }}>
            <AvatarHiplade nameUser={nameUser} size='small' id={auth_user_id} source={avatar_url} />
          </Link>
        </Box>
        {impersonateMode && (
          <Alert severity="warning" sx={{ mr:0 }}>
              Acessando como
          </Alert>
        )}
      </Box>
      <Box
        component="img"
        src={logo_horizontal}
        alt="Logo"
        sx={{
          display: { xs: 'block', lg: 'none' }, // Mostrar logo entre xs e lg
          width: '100px', // Ajuste o tamanho conforme necessário
          margin: 'auto', // Centraliza horizontalmente
          mr: 2,
        }}
      />
      {openMenuMobile && (
        <Box sx={{
          position: 'absolute',
          width: '100vw',
          height: '95vh',
          zIndex: 10,
          top: "100%",
          //backgroundColor: "green"
        }}>
          <Menu showMenu={true} />
        </Box>
      )}
    </Box>
  )
}
